var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 14,
    r: 12.75,
    stroke: "white",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78724 16.9563C2.80117 19.2103 1.34569 20.4953 1.59354 21.2889C1.95209 22.4369 10.9188 20.6579 21.6214 17.3153C32.3239 13.9727 40.7093 10.3324 40.3508 9.18433C40.1299 8.47726 37.4914 8.7952 32.3454 9.99024",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbyIcon);
export default __webpack_public_path__ + "static/media/orbyIcon.fabc52f45d207fa8a97461db7ea4e0ef.svg";
export { ForwardRef as ReactComponent };